

<template>
    <div class="card">
        
    </div>
</template>



<script>



export default {
    name: 'ProfileUploadImagePopup',
    components: {
    },
    props: {
    },
    data(){
        return {
            
        }
    },
    async mounted(){
    },
    methods: {
        async show(){

        },
        async hide(){

        },

    },
    inject: {
    },
    provide(){
        return{}
    }
}

</script>


<style scoped>

</style>

